import { useMemo } from 'react';
import PropTypes from 'prop-types';

import useDetailTable from '#/hooks/table/useDetailTable';
import DetailTable from '#/modules/commonComponents/table/DetailTable';
import { sumExpenseAmounts } from '#/modules/momMgmt/workOrder/helper/workOrderExpenses';
import { formatDisplayAmount } from '#/utils/formatNumber';

const columns = [
  {
    id: 'name',
    header: '名稱',
    accessorFn: (row) => row?.name || '—',
    size: 240,
    enableSorting: false,
    meta: { cellClassName: 'td_left' },
  },
  {
    id: 'amount',
    header: '金額',
    accessorFn: (row) => formatDisplayAmount(row?.amount),
    size: 140,
    enableSorting: false,
    meta: { cellClassName: 'td_right' },
  },
  {
    id: 'currency',
    header: '幣別',
    accessorFn: (row) => row?.currency || 'TWD',
    size: 80,
    enableSorting: false,
  },
];

/** 工單有效費用（detail `expenses[]`，依 display_order）。 */
const WorkOrderExpensesTable = ({ rows = [] }) => {
  const tableRows = useMemo(
    () => [...(rows ?? [])]
      .sort((left, right) => (left?.displayOrder ?? 0) - (right?.displayOrder ?? 0))
      .map((row, index) => ({ ...row, id: row?.id ?? `expense-${index}` })),
    [rows],
  );

  const detailTableState = useDetailTable(tableRows, columns, {
    enableExpanding: false,
    getRowId: (row) => String(row.id),
  });

  if (tableRows.length === 0) {
    return <p className="px-4 py-5 text-sm text-muted-foreground">尚無費用</p>;
  }

  return (
    <div className="detail-table-container">
      <DetailTable
        state={detailTableState}
        containerClassName="detail-table-scroll--section-embedded"
        tableClassName="detail-table--flat-lines"
      />
      <p className="px-4 py-2 text-right text-sm text-slate-700">
        合計 {formatDisplayAmount(sumExpenseAmounts(tableRows))} TWD
      </p>
    </div>
  );
};

WorkOrderExpensesTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object),
};

export default WorkOrderExpensesTable;
